/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 26.05.17.
 */

import React from "react";
import PropTypes from "prop-types";

import BaseDynamicContainer from "../../containers/BaseDynamicContainer";
import {SessionStore} from "../../services/Session";
import AskPasswordModal from "./AskPasswordModal";

class AskPasswordContainer extends BaseDynamicContainer {
    static propTypes = {
        /**
         * onClose(okClicked);
         */
        onClose: PropTypes.func.isRequired
    };

    static defaultProps = {
        selectRole: false
    };

    constructor(props) {
        super(props, {
            authSession: "session",
            session: SessionStore
        });

        this.state.email = this.state.session.currentRecord.person.email;
        this.state.authType = this.state.session.currentRecord.authType;

        this.onClose = this.onClose.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    /**
     *
     * @param {string} key
     * @param {SessionState} newState
     */
    loadingFinished(key, newState) {
        if (key === "authSession" && newState.action && newState.action.method === "post") {
            this.props.onClose(true);
        }
    }

    loadingFailed(key, newState) {
        super.loadingFailed(key, newState);
        if (key === "authSession") {
            if (newState.action.error && newState.action.error.reason === "auth:twoFactorRequired") {
                this.setState({
                    authType: "T"
                });
            } else {
                let errors = this.getErrorList(newState.action);
                this.setState({errors: errors});
            }
        }
    }

    onClose(okClicked) {
        if (okClicked) {
            this.actions("authSession").post({
                status: "P",
                authType: this.state.authType,
                person: {
                    email: this.state.session.currentRecord.person.email,
                    password: this.state.password,
                    authCode: this.state.code
                }
            });
        } else {
            this.props.onClose(okClicked);
        }
    }

    onChange(field, value) {
        this.setState({[field]: value});
    }

    render() {
        return (
            <AskPasswordModal
                validation={this.state.errors}
                askCode={this.state.authType == "T"}
                email={this.state.session.currentRecord.person.email}
                password={this.state.password}
                code={this.state.code}
                disabled={this.state.authSession.isLoading}
                onChange={this.onChange}
                onClose={this.onClose}/>
        );
    }
}

export default AskPasswordContainer;
